import { z } from 'zod'

export const UserTokenSchema = z.object({
  token: z.string(),
})

export const UserLoginSchema = z.object({
  email: z.string().email(),
  password: z.string(),
})

export const UserSchema = z.object({
  id: z.number(),
  image: z.string().url(),
  display_name: z.string(),
})

export const UserListSchema = z.array(UserSchema)

export type IUser = z.infer<typeof UserSchema>
